export class User {
  public id: number;
  public userId: number;
  public password: string;
  public givenName: string;
  public familyName: string;
  public email: string;
  public userName: string;
  public organizationId: number;
  public roles: string[];
  public locked: boolean;
  public mustChangePassword: boolean;
}
